export default [
  {
    path: '/in-cell-visits/home',
    name: 'in-cell-visits-home',
    meta: {
      protected: true,
      requiresPermission: ['allow_in_cell_calls'],
      pageTitle: 'In-Room Calls',
    },
    component: () => import('@/views/inCellVisits/InCellVisitsHome.vue'),
  },
  {
    path: '/in-cell-visits',
    name: 'in-cell-visits',
    meta: {
      protected: true,
      requiresPermission: ['allow_in_cell_calls'],
      pageTitle: 'In-Room Calls',
    },
    component: () => import('@/views/inCellVisits/InCellVisits.vue'),
  },
  {
    path: '/in-cell-visits/:id/details',
    name: 'in-cell-visit-details',
    meta: {
      protected: true,
      requiresPermission: ['allow_in_cell_calls'],
      pageTitle: 'In-Room Call Details',
    },
    component: () => import('@/views/inCellVisits/InCellVisitDetails.vue'),
  },
  {
    path: '/in-cell-visits/book',
    name: 'book-in-cell-visit',
    meta: {
      protected: true,
      requiresPermission: ['allow_in_cell_calls'],
      pageTitle: 'Book In-Room Call',
    },
    component: () => import('@/views/inCellVisits/BookInCellVisit.vue'),
  },
  {
    path: '/in-cell-visits/booking-slots',
    name: 'in-cell-visit-booking-slots',
    meta: {
      protected: true,
      requiresPermission: ['allow_in_cell_calls'],
      pageTitle: 'In-Room Call Booking Slots',
    },
    component: () => import('@/views/inCellVisits/InCellVisitBookingSlots.vue'),
  },
  {
    path: '/in-cell-visits/requested',
    name: 'requested-in-cell-visits',
    meta: {
      protected: true,
      requiresPermission: ['allow_in_cell_calls'],
      pageTitle: 'In-Room Calls',
      status: 'Requested',
    },
    component: () => import('@/views/inCellVisits/InCellVisits.vue'),
  },
  {
    path: '/in-cell-visits/awaiting-confirmation',
    name: 'awaiting-in-cell-visits',
    meta: {
      protected: true,
      requiresPermission: ['allow_in_cell_calls'],
      pageTitle: 'In-Room Calls',
      status: 'AwaitingConfirmation',
    },
    component: () => import('@/views/inCellVisits/InCellVisits.vue'),
  },
  {
    path: '/in-cell-visits/approved',
    name: 'approved-in-cell-visits',
    meta: {
      protected: true,
      requiresPermission: ['allow_in_cell_calls'],
      pageTitle: 'In-Room Calls',
      status: 'Approved',
    },
    component: () => import('@/views/inCellVisits/InCellVisits.vue'),
  },
  {
    path: '/in-cell-visits/completed',
    name: 'completed-in-cell-visits',
    meta: {
      protected: true,
      requiresPermission: ['allow_in_cell_calls'],
      pageTitle: 'In-Room Calls',
      status: 'Completed',
    },
    component: () => import('@/views/inCellVisits/InCellVisits.vue'),
  },
  {
    path: '/in-cell-visits/cancelled',
    name: 'cancelled-in-cell-visits',
    meta: {
      protected: true,
      requiresPermission: ['allow_in_cell_calls'],
      pageTitle: 'In-Room Calls',
      status: 'Cancelled',
    },
    component: () => import('@/views/inCellVisits/InCellVisits.vue'),
  },
  {
    path: '/in-cell-visits/rejected',
    name: 'rejected-in-cell-visits',
    meta: {
      protected: true,
      requiresPermission: ['allow_in_cell_calls'],
      pageTitle: 'In-Room Calls',
      status: 'Rejected',
    },
    component: () => import('@/views/inCellVisits/InCellVisits.vue'),
  },
  {
    path: '/in-cell-visits/booking-slots/create',
    name: 'create-in-cell-booking-slot',
    component: () => import('@/views/inCellVisits/CreateInCellBookingSlot.vue'),
    meta: {
      protected: true,
      pageTitle: 'Create In-Room Booking Slot',
    },
  },
  {
    path: '/in-cell-visits/booking-slots/:bookingSlotId/edit',
    name: 'update-in-cell-booking-slot',
    component: () => import('@/views/inCellVisits/UpdateInCellBookingSlot.vue'),
    meta: {
      protected: true,
      pageTitle: 'Update In-Room Booking Slot',
    },
  },
];
